import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { captureAttributionOnLoad } from "@/lib/attribution";

// Iter-52.55.13 — defensive service-worker unregister.
// The app has never shipped a service worker, but some customers may
// have installed a PWA in the past (via `Add to Home Screen` on
// Chrome/Safari) and their phone still has an old registration that
// intercepts network requests and serves stale bundles. Unregistering
// on every boot is safe (no-op if none exist) and guarantees no user
// gets permanently stuck on an old build.
if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  try {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((reg) => { try { reg.unregister(); } catch { /* noop */ } });
    }).catch(() => { /* noop */ });
    // Also purge Cache Storage entries, which some old workers used
    // to cache index.html / bundle chunks.
    if ('caches' in window) {
      caches.keys().then((keys) => {
        keys.forEach((k) => { try { caches.delete(k); } catch { /* noop */ } });
      }).catch(() => { /* noop */ });
    }
  } catch { /* noop */ }
}

// Iter-52.25 — capture first-touch UTM / fbclid / referrer BEFORE the
// app mounts, so a redirect that eats the query string still keeps
// the ad-source data.
captureAttributionOnLoad();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
